import { PrimaryFullScreenSpinner, TabLink, TabLinkContainer } from "@repo/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Suspense } from "react";
import { AdminPageContainer } from "~/components/layout/AdminPageContainer";
import { AdminPageHeader } from "~/components/layout/AdminPageHeader";
import { opsHead } from "~/head";

export const Route = createFileRoute("/__auth/currencycloud")({
  head: () => opsHead("Currencycloud"),
  component: () => (
    <Suspense fallback={<PrimaryFullScreenSpinner />}>
      <View />
    </Suspense>
  ),
});

function View() {
  return (
    <AdminPageContainer testId="admin-currencycloud">
      <AdminPageHeader title="Currencycloud Integration" />

      <TabLinkContainer className="mb-10" size="sm">
        <TabLink title="Accounts" to="/currencycloud" end />
        <TabLink title="Rates" to="/currencycloud/rates" />
      </TabLinkContainer>

      <div className="flex">
        <Outlet />
      </div>
    </AdminPageContainer>
  );
}
